import {type IconName, type SelectFieldOption} from '@wandb/components';

import {type ArtifactVersionMetricChartType} from './types';

type BasicChartPanelItem = {
  type: ArtifactVersionMetricChartType;
  label: string;
  icon: IconName;
  description: string;
};

export const BASIC_CHART_PANEL_ITEMS: BasicChartPanelItem[] = [
  {
    type: 'line',
    label: 'Line Plot',
    icon: 'chart-line-plot',
    description: 'Compare a metric across versions',
  },
  {
    type: 'bar',
    label: 'Bar chart',
    icon: 'chart-vertical-bars',
    description: 'Compare values side by side',
  },
  {
    type: 'scatter',
    label: 'Scatter plot',
    icon: 'chart-scatterplot',
    description: 'Plot two metrics against each other',
  },
];

export const CONFIGURE_METRIC_PLACEHOLDER_ICON: IconName = 'chart-line-plot';
export const DEFAULT_PLACEHOLDER_ICON = 'lightbulb-info';

export const BASIC_CHART_PANEL_SELECT_ITEMS: SelectFieldOption[] =
  BASIC_CHART_PANEL_ITEMS.map(item => ({
    id: item.type,
    label: item.label,
    description: item.description,
  }));

const CHART_TYPE_LABEL_BY_ID = Object.fromEntries(
  BASIC_CHART_PANEL_ITEMS.map(item => [item.type, item.label])
) as Record<ArtifactVersionMetricChartType, string>;

const CHART_TYPE_ICON_BY_ID = Object.fromEntries(
  BASIC_CHART_PANEL_ITEMS.map(item => [item.type, item.icon])
) as Record<ArtifactVersionMetricChartType, IconName>;

export function getBasicChartPanelLabel(
  chartType: ArtifactVersionMetricChartType
): string {
  return CHART_TYPE_LABEL_BY_ID[chartType];
}

export function getBasicChartPanelIcon(
  chartType: ArtifactVersionMetricChartType
): IconName {
  return CHART_TYPE_ICON_BY_ID[chartType];
}
